import { render } from "./App.vue?vue&type=template&id=09f2865c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=09f2865c&lang=css"

import exportComponent from "/Users/bellakwon/Desktop/thesis01/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__